// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"688410c8","224":"a8172192","282":"508c098a","364":"c6b5ac0e","408":"137ad50b","499":"14ddc50d","620":"5fc0dcf0","628":"35705a50","806":"1fc9b76e"}[chunkId] + ".chunk.js";
};